import { useState, useRef, useEffect, useCallback } from "react"
import { toast } from "react-toastify";
import { getRequest, postRequest } from "../../utils/api";
import PaginationComponent from "../../Component/Pagination/pagination";
import { logout } from "../../utils/auth";
import Loader from "../../Component/Loader/Loader";
import Swal from 'sweetalert2'
import QRCode from "react-qr-code";
import moment from "moment";
import { REDIRECT_URL } from "../../utils/api";
const QrGenerator = () => {
    const [qrList, setQrList] = useState<any[]>([]);
    const [page, setPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [totalRecords, setTotalRecords] = useState<number>(0);
    const [isLoader, setIsLoader] = useState<boolean>(true);
    const [batchCount, setBatchCount] = useState<number>(10);

    // For Assigning WhatsApp Number
    const [selectedQr, setSelectedQr] = useState<any>(null);
    const [whatsappNumber, setWhatsappNumber] = useState("");
    const [prefilledMessage, setPrefilledMessage] = useState("");

    const LOGO_URL = "/dist/img/logo-icon.png";

    const getQrList = useCallback(async (currentPage: number) => {
        try {
            setIsLoader(true);
            const response = await getRequest(`/qr/qrList?page=${currentPage}`);
            if (response.status === 'success') {
                setQrList(response.data as any[]);
                setTotalPages(response.pagination.totalPages);
                setTotalRecords(response.pagination.totalRecords);
                setIsLoader(false);
            } else if (response.status === 'session_expired') {
                setIsLoader(false);
                logout();
            } else {
                setIsLoader(false);
                toast.error(response.message);
            }
        } catch (error) {
            setIsLoader(false);
            toast.error("Something went wrong!");
        }
    }, []);

    const isFirstRender = useRef(false);
    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = true;
            return;
        }
        getQrList(page);
    }, [page, getQrList]);

    const handleGenerateBatch = async () => {
        const result = await Swal.fire({
            title: `Generate ${batchCount} QRs?`,
            icon: 'question',
            showCancelButton: true,
            confirmButtonText: 'Generate',
            customClass: { confirmButton: "btn btn-dark", cancelButton: "btn btn-light" }
        });

        if (result.isConfirmed) {
            try {
                setIsLoader(true);
                const response = await postRequest("/qr/generateBatch", { count: batchCount });
                if (response.status === "success") {
                    toast.success(response.message);
                    getQrList(1);
                }
            } catch (error) {
                toast.error("Batch generation failed");
            } finally {
                setIsLoader(false);
            }
        }
    };

    const handleAssignQr = async () => {
        if (!whatsappNumber) return toast.error("Please enter a WhatsApp number");
        try {
            setIsLoader(true);
            const response = await postRequest("/qr/assignQr", {
                qr_unique_id: selectedQr.qr_unique_id,
                target_number: whatsappNumber,
                message: prefilledMessage
            });
            if (response.status === "success") {
                toast.success("QR assigned successfully");
                setSelectedQr(null);
                getQrList(page);
            }
        } catch (error) {
            toast.error("Update failed");
        } finally {
            setIsLoader(false);
        }
    };

    const downloadQR = (uniqueId: string, id: number) => {
        const svg = document.getElementById(`qr-svg-${id}`) as any;
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const qrImg = new Image();
        const logoImg = new Image();

        canvas.width = 1000;
        canvas.height = 1000;

        qrImg.onload = () => {
            if (ctx) {
                ctx.fillStyle = "white";
                ctx.fillRect(0, 0, 1000, 1000);
                ctx.drawImage(qrImg, 0, 0, 1000, 1000);

                logoImg.onload = () => {
                    const logoSize = 200;
                    const pos = (1000 - logoSize) / 2;
                    ctx.fillStyle = "white";
                    ctx.beginPath();
                    ctx.roundRect(pos - 5, pos - 5, logoSize + 10, logoSize + 10, 20);
                    ctx.fill();
                    ctx.drawImage(logoImg, pos, pos, logoSize, logoSize);

                    const pngFile = canvas.toDataURL("image/png");
                    const downloadLink = document.createElement("a");
                    downloadLink.download = `${uniqueId}.png`;
                    downloadLink.href = pngFile;
                    downloadLink.click();
                };
                logoImg.src = LOGO_URL;
            }
        };
        qrImg.src = "data:image/svg+xml;base64," + btoa(svgData);
    };

    return (
        <div className="hk-pg-wrapper">
            {isLoader && <Loader />}
            <div className="hk-pg-body py-0">
                <div className="page-wrap">
                    <div className="page-content ps-0">
                        <div className="page-detail-wrap">
                            <header className="page-header">
                                <div>
                                    <div className="page-title">
                                        <h2 className="mb-0">QR Code Generator</h2>
                                    </div>
                                </div>
                                <div className="page-options-wrap">
                                    <div className="d-flex align-items-center me-3">
                                        <input type="number" className="form-control form-control-sm" style={{ width: '70px' }} value={batchCount} onChange={(e) => setBatchCount(parseInt(e.target.value))} />
                                    </div>
                                    <button type="button" className="btn btn-primary btn-rounded" onClick={handleGenerateBatch}>
                                        <span>
                                            <span className="icon"><i className="ri-qr-code-line"></i></span>
                                            <span>Generate Batch</span>
                                        </span>
                                    </button>
                                    <div className="v-separator d-lg-inline-block d-none"></div>
                                    <a className="btn btn-icon btn-flush-dark btn-rounded flush-soft-hover hk-navbar-togglable d-lg-inline-block d-none" href="#">
                                        <span className="btn-icon-wrap">
                                            <span className="feather-icon"><i className="ri-arrow-up-s-line ri-lg"></i></span>
                                        </span>
                                    </a>
                                </div>
                            </header>

                            <div className="page-body">
                                <div data-simplebar className="nicescroll-bar">
                                    <div className="container-fluid">
                                        <div className="row">
                                            <div className="col-lg-12">
                                                <div className="card">
                                                    <div className="card-header card-header-action">
                                                        <h6>Dynamic QR List</h6>
                                                    </div>
                                                    <div className="table-responsive">
                                                        <table className="table table-hover mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center" style={{ width: '30px' }}>
                                                                        <input type="checkbox" className="form-check-input" />
                                                                    </th>
                                                                    <th>ID</th>
                                                                    <th>Branded QR</th>
                                                                    <th>WhatsApp Config</th>
                                                                    <th className="text-center">Status</th>
                                                                    <th>Scans</th>
                                                                    <th>Created Date</th>
                                                                    <th className="text-center">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {qrList && qrList.length > 0 ? (
                                                                    qrList.map((item) => (
                                                                        <tr key={item.qr_unique_id}>
                                                                            <td className="text-center"><input type="checkbox" className="form-check-input" /></td>
                                                                            <td><span className="fw-bold">{item.qr_unique_id}</span></td>
                                                                            <td>
                                                                                <div style={{ position: 'relative', display: 'inline-block', padding: '5px', background: '#fff', border: '1px solid #eee' }}>
                                                                                    <QRCode id={`qr-svg-${item.qr_unique_id}`} value={`${REDIRECT_URL}/scan/${item.qr_unique_id}`} size={60} level="H" />
                                                                                    <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', background: 'white', padding: '1px', borderRadius: '2px' }}>
                                                                                        <img src={LOGO_URL} alt="logo" style={{ width: '12px', height: '12px' }} />
                                                                                    </div>
                                                                                </div>
                                                                            </td>
                                                                            <td>
                                                                                <div className="fs-13">
                                                                                    <div className="fw-bold text-dark">{item.qr_target_number || 'Unassigned'}</div>
                                                                                    <p className="mb-0 text-muted fs-12 text-truncate" style={{maxWidth:'150px'}}>{item.qr_prefilled_message || '–'}</p>
                                                                                </div>
                                                                            </td>
                                                                            <td className="text-center">
                                                                                {item.qr_status ? <span className="badge bg-success">ACTIVE</span> : <span className="badge bg-warning">PENDING</span>}
                                                                            </td>
                                                                            <td><span className="badge bg-primary-subtle text-primary">{item.qr_scan_count || 0}</span></td>
                                                                            <td>{moment(item.createdAt).format('DD MMM, YYYY')}</td>
                                                                            <td className="text-center">
                                                                                <div className="d-flex align-items-center justify-content-center gap-1">
                                                                                    <button className="btn btn-icon btn-sm btn-flush-dark btn-border flush-soft-hover" onClick={() => {
                                                                                        setSelectedQr(item);
                                                                                        setWhatsappNumber(item.qr_target_number || "");
                                                                                        setPrefilledMessage(item.qr_prefilled_message || "");
                                                                                    }}>
                                                                                        <span className="icon"><i className="ri-settings-4-line"></i></span>
                                                                                    </button>
                                                                                    <button className="btn btn-icon btn-sm btn-flush-dark btn-border flush-soft-hover" onClick={() => downloadQR(item.qr_unique_id, item.qr_unique_id)}>
                                                                                        <span className="icon"><i className="ri-download-2-line"></i></span>
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                ) : (
                                                                    <tr><td colSpan={8} className="text-center">No Records Found</td></tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    <div className="card-footer d-flex justify-content-between align-items-center">
                                                        <div className="col-sm">
                                                            <div className="text-muted">Showing <span className="fw-semibold">{qrList?.length || 0}</span> of <span className="fw-semibold">{totalRecords || 0}</span> Results</div>
                                                        </div>
                                                        {totalPages > 0 && <PaginationComponent totalPages={totalPages} currentPage={page} setCurrentPage={setPage} />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Quick Assign Modal */}
            {selectedQr && (
                <div className="modal fade show d-block" style={{ background: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Assign QR: {selectedQr.qr_unique_id}</h5>
                                <button type="button" className="btn-close" onClick={() => setSelectedQr(null)}></button>
                            </div>
                            <div className="modal-body">
                                <div className="mb-3">
                                    <label className="form-label">WhatsApp Number</label>
                                    <input type="text" className="form-control" placeholder="e.g. 919876543210" value={whatsappNumber} onChange={(e) => setWhatsappNumber(e.target.value)} />
                                </div>
                                <div className="mb-3">
                                    <label className="form-label">Pre-filled Message</label>
                                    <textarea className="form-control" rows={3} value={prefilledMessage} onChange={(e) => setPrefilledMessage(e.target.value)} placeholder="Enter default chat message..."></textarea>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-light" onClick={() => setSelectedQr(null)}>Cancel</button>
                                <button className="btn btn-primary" onClick={handleAssignQr}>Save & Activate</button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}

export default QrGenerator;